import BossPolicy from "@/policies/BossPolicy";
import Product from "@/models/Proposal/Product/Product";

export default class AbstractPolicy extends BossPolicy{

    static moveOptional(user, product) {
        if (this._isAgentLocked(product)) {
            return false;
        }

        if (product.proposal_cancellation_id) {
            return false;
        }

        if (this._isProposalLocked(product)) {
            return false;
        }

        return user.HasPermission('customers.dossiers.proposals.write');
    }

    static delete(user, product) {
        if (product.proposal_cancellation_id) {
            return false;
        }

        if (this._isAgentLocked(product)) {
            return false;
        }

        if (this._isProposalLocked(product)) {
            return false;
        }

        return user.HasPermission('customers.dossiers.proposals.write');
    }

    static deleteAgentAccepted() {
        return false;
    }

    static updatePurchasePrices(user, product) {
        if (product.proposal_cancellation_id) {
            return false;
        }

        if (this._isProposalLocked(product) && !user.HasPermission('customers.dossiers.proposals.purchase-price')) {
            return false;
        }

        return user.HasPermission('customers.dossiers.proposals.write');
    }

    static updateSalePrices(user, product) {
        if (product.proposal_cancellation_id) {
            return false;
        }

        if (this._isProposalLocked(product)) {
            return false;
        }

        return user.HasPermission('customers.dossiers.proposals.write');
    }

    static updateNotes (user) {
        return user.HasPermission('customers.dossiers.proposals.write');
    }

    static updateDates (user, product) {
        if (product.proposal_cancellation_id) {
            return false;
        }

        if (this._isAgentLocked(product)) {
            return false;
        }

        if (this._isProposalLocked(product)) {
            return false;
        }

        return user.HasPermission('customers.dossiers.proposals.write');
    }

    static updateDetailAssignment (user, product) {
        if (product.proposal_cancellation_id) {
            return false;
        }

        if (this._isAgentLocked(product)) {
            return false;
        }

        if (this._isProposalLocked(product)) {
            return false;
        }

        return user.HasPermission('customers.dossiers.proposals.write');
    }

    static _isProposalLocked(product) {
        const productData = Product.query().with(['group.proposal', 'upsell.proposal', 'cancellation.proposal']).find(product.id);
        const proposal = productData.group?.proposal ?? productData.upsell.proposal ?? productData.cancellation.proposal;

        return proposal.locked;
    }

    static _isAgentLocked(product) {
        const productData = Product.query().with(['agentPreset.agentProduct.status']).find(product.id);
        const agentStatus = productData.agentPreset?.agentProduct?.status;

        return agentStatus && agentStatus.locked;
    }
}
